/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ButtonListPosition*`'s.
 */
export type ButtonListPosition =
  | ButtonListPositionLeft
  | ButtonListPositionMiddle
  | ButtonListPositionRight
  | ButtonListPositionSpaceBetween;

/**
 * The Button List position left type.
 */
export type ButtonListPositionLeft = typeof BUTTON_LIST_POSITION_LEFT;

/**
 * The Button List position middle type.
 */
export type ButtonListPositionMiddle = typeof BUTTON_LIST_POSITION_MIDDLE;

/**
 * The Button List position right type.
 */
export type ButtonListPositionRight = typeof BUTTON_LIST_POSITION_RIGHT;

/**
 * The Button List position space between type.
 */
export type ButtonListPositionSpaceBetween = typeof BUTTON_LIST_POSITION_SPACE_BETWEEN;

/**
 * The Button List position left constant.
 */
export const BUTTON_LIST_POSITION_LEFT = `left`;

/**
 * The Button List position middle constant.
 */
export const BUTTON_LIST_POSITION_MIDDLE = `middle`;

/**
 * The Button List position right constant.
 */
export const BUTTON_LIST_POSITION_RIGHT = `right`;

/**
 * The Button List position space between constant.
 */
export const BUTTON_LIST_POSITION_SPACE_BETWEEN = `space-between`;
